
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 41 28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.7 2c0-.53-.216-1.04-.6-1.414A2.076 2.076 0 0026.65 0H2.05C1.506 0 .985.21.6.586.216.96 0 1.47 0 2c0 .53.216 1.04.6 1.414.385.375.906.586 1.45.586H12.3v22c0 .53.216 1.04.6 1.414.385.375.906.586 1.45.586.544 0 1.065-.21 1.45-.586.384-.375.6-.884.6-1.414V4h10.25c.544 0 1.065-.21 1.45-.586.384-.375.6-.884.6-1.414zm10.25 10h-12.3c-.544 0-1.065.21-1.45.586-.384.375-.6.884-.6 1.414 0 .53.216 1.04.6 1.414.385.375.906.586 1.45.586h4.1v10c0 .53.216 1.04.6 1.414.385.375.906.586 1.45.586.544 0 1.065-.21 1.45-.586.384-.375.6-.884.6-1.414V16h4.1c.544 0 1.065-.21 1.45-.586.384-.375.6-.884.6-1.414 0-.53-.216-1.04-.6-1.414A2.076 2.076 0 0038.95 12z"}})])
          )
        }
      }
    